import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { loadSite, loadContent } from './services/siteData';
import './styles/global.css';
import './styles/portal.css';

// Kick off the live website snapshot + editorial content fetches (fire-and-forget).
// The stores start from the seed/defaults, so first paint is instant; live data
// swaps in when ready.
void loadSite();
void loadContent();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
